import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { set } from "lodash";
import { getCurrentInstance, onMounted } from "vue";
import TrackingComposition from "../../../../shared-common/src/composition/tracking.ts"

const __default__ = { name: "MasButton" };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  trackIngCategory: {
    type: String,
  },
  trackingDesc: {
    type: String,
  }
},
  setup(__props) {

const props = __props

const { trackEvent } = TrackingComposition()
 const { proxy } = getCurrentInstance() as any;

const trackClick = () => {
  if(props.trackIngCategory){
    trackEvent(props);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    class: "mas-button",
    onClick: _withModifiers(trackClick, ["prevent"])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["onClick"]))
}
}

})